// extracted by mini-css-extract-plugin
export default {"menu-bar":"styles_menu-bar__8hXPj","menu-list":"styles_menu-list__FCHEG","nav-item":"styles_nav-item__-dVuk","link":"styles_link__slniw"};